module.exports = __webpack_public_path__ + "static/media/assistant.11de3bf4.svg";